import { useNavigate } from 'react-router-dom';
import { Form, Formik, FormikProps } from 'formik';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { DealerApiAccessSchemaYup, dealerApiAccessInitialValues } from './validationSchema';

export default function DealerApiAccessFormContainer() {
  const navigate = useNavigate();

  // TODO: wire up to the API once the backend exists
  const handleSubmit = async (_values: typeof dealerApiAccessInitialValues) => {};

  return (
    <Grid size={{ xs: 12 }}>
      <div className="dealer-api-access-form">
        <h2 className="pb-2 mt-4 mb-3 border-bottom">New Dealer API Access</h2>
        <Formik
          initialValues={dealerApiAccessInitialValues}
          validationSchema={DealerApiAccessSchemaYup}
          onSubmit={handleSubmit}
        >
          {({ handleChange, handleBlur, values, touched, errors, isSubmitting }: FormikProps<any>) => (
            <Form noValidate>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    name="name"
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && String(errors.name || '')}
                  />
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ display: 'flex', gap: 1, my: 2 }}>
                <Button variant="contained" type="submit" disabled={isSubmitting}>
                  Save
                </Button>
                <Button variant="outlined" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    </Grid>
  );
}
